import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const DiscoverNewPasswordComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "DiscoverNewPasswordPage" */ "@circle-react/components/Discover/ForgotPasswordPage"
    ),
);

export const DiscoverNewPasswordPage = () => (
  <Suspense fallback={<PageLoader />}>
    <DiscoverNewPasswordComponent />
  </Suspense>
);
